// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrivacyConsent-module__privacyConsent__crVpR {
  padding: 1rem;
  border-radius: var(--mantine-radius-md);
  background-color: var(--mantine-color-gray-0);
  border: 1px solid var(--mantine-color-gray-3);
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.PrivacyConsent-module__privacyConsentError__Yh17t {
  background-color: var(--mantine-color-red-0);
  border-color: var(--mantine-color-red-4);
}

.PrivacyConsent-module__privacyConsentCheckbox__KKJe3 {
  align-items: flex-start;
  cursor: pointer;
}

.PrivacyConsent-module__privacyConsentCheckboxBody__uYHDK {
  align-items: flex-start;
}

.PrivacyConsent-module__privacyConsentCheckboxInner__tiBLz {
  margin-top: 2px;
  cursor: pointer;
}

.PrivacyConsent-module__privacyConsentCheckboxInput__BHizL {
  cursor: pointer;
}

.PrivacyConsent-module__privacyConsentCheckbox__KKJe3 .mantine-Checkbox-label {
  cursor: pointer;
}

.PrivacyConsent-module__privacyConsentLabel__wqtrC {
  line-height: 1.5;
  color: var(--mantine-color-gray-7);
}

.PrivacyConsent-module__privacyConsentLink__Nu8Ic {
  font-weight: 500;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  font-size: inherit;
}

.PrivacyConsent-module__privacyConsentLink__Nu8Ic:hover {
  text-decoration-thickness: 2px;
}

.PrivacyConsent-module__privacyConsentErrorText__Zqhll {
  margin-top: 0.5rem;
  font-weight: 500;
}

.PrivacyConsent-module__privacyDrawerBody__wbOyT {
  padding-top: 0;
}

.PrivacyConsent-module__privacyTermsParagraph__u62yw {
  line-height: 1.7;
  color: var(--mantine-color-gray-7);
  text-align: justify;
}

.PrivacyConsent-module__privacyTermsParagraph__u62yw:first-child {
  font-weight: 400;
  font-size: var(--mantine-font-size-sm);
  color: var(--mantine-color-dark-6);
}

[data-mantine-color-scheme='dark'] .PrivacyConsent-module__privacyConsent__crVpR {
  background-color: var(--mantine-color-dark-6);
  border-color: var(--mantine-color-dark-4);
}

[data-mantine-color-scheme='dark'] .PrivacyConsent-module__privacyConsentError__Yh17t {
  background-color: color-mix(in srgb, var(--mantine-color-red-9) 15%, transparent);
  border-color: var(--mantine-color-red-7);
}

[data-mantine-color-scheme='dark'] .PrivacyConsent-module__privacyConsentLabel__wqtrC {
  color: var(--mantine-color-gray-3);
}

[data-mantine-color-scheme='dark'] .PrivacyConsent-module__privacyTermsParagraph__u62yw {
  color: var(--mantine-color-gray-3);
}

[data-mantine-color-scheme='dark'] .PrivacyConsent-module__privacyTermsParagraph__u62yw:first-child {
  color: var(--mantine-color-gray-1);
}

.PrivacyConsent-module__privacyDisclaimer__lYOi3 {
  margin: 2rem 0.5rem 1rem;
  font-size: var(--mantine-font-size-xs);
  color: var(--mantine-color-gray-7);
}

.PrivacyConsent-module__privacyDisclaimer__lYOi3 a {
  color: var(--mantine-color-dark-6);
  text-decoration: underline;
}

.PrivacyConsent-module__privacyDisclaimer__lYOi3 a:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/features/application-form/PrivacyConsent.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uCAAuC;EACvC,6CAA6C;EAC7C,6CAA6C;EAC7C,8DAA8D;AAChE;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,6CAA6C;EAC7C,yCAAyC;AAC3C;;AAEA;EACE,iFAAiF;EACjF,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".privacyConsent {\n  padding: 1rem;\n  border-radius: var(--mantine-radius-md);\n  background-color: var(--mantine-color-gray-0);\n  border: 1px solid var(--mantine-color-gray-3);\n  transition: border-color 0.2s ease, background-color 0.2s ease;\n}\n\n.privacyConsentError {\n  background-color: var(--mantine-color-red-0);\n  border-color: var(--mantine-color-red-4);\n}\n\n.privacyConsentCheckbox {\n  align-items: flex-start;\n  cursor: pointer;\n}\n\n.privacyConsentCheckboxBody {\n  align-items: flex-start;\n}\n\n.privacyConsentCheckboxInner {\n  margin-top: 2px;\n  cursor: pointer;\n}\n\n.privacyConsentCheckboxInput {\n  cursor: pointer;\n}\n\n.privacyConsentCheckbox :global(.mantine-Checkbox-label) {\n  cursor: pointer;\n}\n\n.privacyConsentLabel {\n  line-height: 1.5;\n  color: var(--mantine-color-gray-7);\n}\n\n.privacyConsentLink {\n  font-weight: 500;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  cursor: pointer;\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: inherit;\n}\n\n.privacyConsentLink:hover {\n  text-decoration-thickness: 2px;\n}\n\n.privacyConsentErrorText {\n  margin-top: 0.5rem;\n  font-weight: 500;\n}\n\n.privacyDrawerBody {\n  padding-top: 0;\n}\n\n.privacyTermsParagraph {\n  line-height: 1.7;\n  color: var(--mantine-color-gray-7);\n  text-align: justify;\n}\n\n.privacyTermsParagraph:first-child {\n  font-weight: 400;\n  font-size: var(--mantine-font-size-sm);\n  color: var(--mantine-color-dark-6);\n}\n\n:global([data-mantine-color-scheme='dark']) .privacyConsent {\n  background-color: var(--mantine-color-dark-6);\n  border-color: var(--mantine-color-dark-4);\n}\n\n:global([data-mantine-color-scheme='dark']) .privacyConsentError {\n  background-color: color-mix(in srgb, var(--mantine-color-red-9) 15%, transparent);\n  border-color: var(--mantine-color-red-7);\n}\n\n:global([data-mantine-color-scheme='dark']) .privacyConsentLabel {\n  color: var(--mantine-color-gray-3);\n}\n\n:global([data-mantine-color-scheme='dark']) .privacyTermsParagraph {\n  color: var(--mantine-color-gray-3);\n}\n\n:global([data-mantine-color-scheme='dark']) .privacyTermsParagraph:first-child {\n  color: var(--mantine-color-gray-1);\n}\n\n.privacyDisclaimer {\n  margin: 2rem 0.5rem 1rem;\n  font-size: var(--mantine-font-size-xs);\n  color: var(--mantine-color-gray-7);\n}\n\n.privacyDisclaimer :global(a) {\n  color: var(--mantine-color-dark-6);\n  text-decoration: underline;\n}\n\n.privacyDisclaimer :global(a:hover) {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"privacyConsent": `PrivacyConsent-module__privacyConsent__crVpR`,
	"privacyConsentError": `PrivacyConsent-module__privacyConsentError__Yh17t`,
	"privacyConsentCheckbox": `PrivacyConsent-module__privacyConsentCheckbox__KKJe3`,
	"privacyConsentCheckboxBody": `PrivacyConsent-module__privacyConsentCheckboxBody__uYHDK`,
	"privacyConsentCheckboxInner": `PrivacyConsent-module__privacyConsentCheckboxInner__tiBLz`,
	"privacyConsentCheckboxInput": `PrivacyConsent-module__privacyConsentCheckboxInput__BHizL`,
	"privacyConsentLabel": `PrivacyConsent-module__privacyConsentLabel__wqtrC`,
	"privacyConsentLink": `PrivacyConsent-module__privacyConsentLink__Nu8Ic`,
	"privacyConsentErrorText": `PrivacyConsent-module__privacyConsentErrorText__Zqhll`,
	"privacyDrawerBody": `PrivacyConsent-module__privacyDrawerBody__wbOyT`,
	"privacyTermsParagraph": `PrivacyConsent-module__privacyTermsParagraph__u62yw`,
	"privacyDisclaimer": `PrivacyConsent-module__privacyDisclaimer__lYOi3`
};
module.exports = ___CSS_LOADER_EXPORT___;
